'use client';

import { HStack, VStack } from '@terra/ui-styled-system';
import { Text } from '../../../components/styled/text';
import { useMemo } from 'react';
import { buildTextDiffLines } from './textDiffUtils';
import { getDiffRowClass, getDiffRowTextColor } from './diffRowStyles';

export function TextDiffView({
  before,
  after,
  field,
}: {
  before: unknown;
  after: unknown;
  field?: string;
}) {
  const diffLinesResult = useMemo(
    () => buildTextDiffLines({ before, after, field }),
    [after, before, field],
  );

  if (diffLinesResult.length === 0) {
    return null;
  }

  return (
    <VStack
      gap={0}
      width="100%"
      borderRadius="md"
      overflow="hidden"
      fontFamily="mono"
      fontSize="xs"
      borderWidth="1px"
      borderColor="border.subtle"
    >
      {diffLinesResult.map((line, index) => {
        const prefix =
          line.type === 'removed' ? '- ' : line.type === 'added' ? '+ ' : '  ';

        return (
          <HStack
            key={`${line.type}-${index}`}
            gap={0}
            width="100%"
            className={getDiffRowClass(line.type)}
            px={2}
            py={0.5}
          >
            <Text
              fontFamily="mono"
              fontSize="xs"
              color={getDiffRowTextColor(line.type)}
              whiteSpace="pre"
              userSelect="none"
              minWidth="20px"
            >
              {prefix}
            </Text>
            <Text
              fontFamily="mono"
              fontSize="xs"
              color={getDiffRowTextColor(line.type)}
              whiteSpace="pre-wrap"
              flex="1"
            >
              {line.content}
            </Text>
          </HStack>
        );
      })}
    </VStack>
  );
}
